/* Explore Scientific redesign v1 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal on scroll ---- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.es-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- exploded view ---- */
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function explodeCss() {
    if (document.getElementById('es-explode-v20')) return;
    var st = document.createElement('style'); st.id = 'es-explode-v20';
    st.textContent = '.es-explode__hud{opacity:calc(1 - var(--fp,0));transition:opacity .3s}@media (min-width:750px){.es-explode__stage{margin-top:clamp(8px,3vh,36px)}}.es-explode__3d{transition:opacity 1.1s cubic-bezier(.2,.7,.2,1),translate 1.1s cubic-bezier(.2,.7,.2,1)}.es-explode__stage{transition:opacity 1.1s cubic-bezier(.2,.7,.2,1)}.es-explode:not(.is-in) .es-explode__3d{opacity:0;translate:0 60px}.es-explode:not(.is-in) .es-explode__stage{opacity:0}@media (prefers-reduced-motion:reduce){.es-explode__3d,.es-explode__stage{opacity:1!important;translate:none!important;transition:none}}';
    document.head.appendChild(st);
  }
  function initExplode(sec) {
    explodeCss();
    var stage = sec.querySelector('[data-stage]');
    var head = sec.querySelector('[data-head]');
    var foot = sec.querySelector('[data-foot]');
    var eyecup = stage.querySelector('[data-part="eyecup"]');
    var body = stage.querySelector('[data-part="body"]');
    var barrel = stage.querySelector('[data-part="barrel"]');
    var lenses = Array.prototype.slice.call(stage.querySelectorAll('[data-part="lens"]'));
    var ticking = false;
    if (!('IntersectionObserver' in window) || reduce) { sec.classList.add('is-in'); } else { var sio = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { sec.classList.add('is-in'); sio.disconnect(); } }, { threshold: 0.12 }); sio.observe(sec); }
    function place(el, x, op, lp) {
      if (!el) return;
      el.style.transform = 'translate(-50%,-50%) translateX(' + x.toFixed(1) + 'px)';
      el.style.opacity = op;
      var lab = el.querySelector('.es-explode__label');
      if (lab) lab.style.opacity = lp;
    }
    function render() {
      ticking = false;
      var r = sec.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = Math.max(1, r.height - vh);
      var raw = reduce ? 1 : clamp(-r.top / total, 0, 1);
      var p = ease(clamp((raw - 0.12) / 0.6, 0, 1));
      var W = stage.clientWidth, H = stage.clientHeight;
      var bw = body ? body.offsetWidth : 0, ew = eyecup ? eyecup.offsetWidth : 0, rw = barrel ? barrel.offsetWidth : 0;
      var lp = clamp((p - 0.7) / 0.3, 0, 1);
      var n = lenses.length;
      var e0 = -(bw / 2 + ew / 2 - 8), e1 = -(W / 2 - ew / 2);
      var b0 = bw / 2 + rw / 2 - 8, b1 = W / 2 - rw / 2;
      place(eyecup, e0 + (e1 - e0) * p, 1, lp);
      place(body, 0, 1 - p * 0.92, 0);
      place(barrel, b0 + (b1 - b0) * p, 1, lp);
      var left = e1 + ew / 2 + 30, right = b1 - rw / 2 - 30;
      lenses.forEach(function (el, i) {
        var t = (i + 0.5) / n;
        var packed = (-0.32 + t * 0.64) * bw;
        var spread = left + (right - left) * t;
        place(el, packed + (spread - packed) * p, clamp(p * 3, 0, 1), lp);
      });
      var narrow = W < 700;
      [eyecup].concat(lenses, [barrel], [body]).forEach(function (el, i) {
        if (!el) return;
        var lab = el.querySelector('.es-explode__label');
        if (!lab) return;
        var above = narrow && i % 2 === 1;
        lab.classList.toggle('is-above', above);
        lab.style.top = above ? (-(H - el.offsetHeight) / 2 - lab.offsetHeight - 14) + 'px' : ((H + el.offsetHeight) / 2 + 14) + 'px';
      });
      if (head) head.style.opacity = 1 - clamp((raw - 0.05) / 0.2, 0, 1) * 0.9;
      var fp = clamp((raw - 0.82) / 0.12, 0, 1); sec.style.setProperty('--fp', fp); if (foot) foot.style.setProperty('--fp', fp);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(render); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    render();
  }

  /* ---- telescope calculator ---- */
  function initCalc(sec) {
    var sel = sec.querySelector('[data-scope]');
    var flIn = sec.querySelector('input[data-fl]');
    var apIn = sec.querySelector('input[data-ap]');
    var heads = sec.querySelectorAll('[data-col]');
    var cells = { mag: sec.querySelectorAll('[data-calc="mag"]'), tfov: sec.querySelectorAll('[data-calc="tfov"]'), ep: sec.querySelectorAll('[data-calc="ep"]') };
    function fmtDeg(d) { return d >= 1 ? d.toFixed(2) + '°' : Math.round(d * 60) + '′'; }
    function update() {
      var fl = parseFloat(flIn.value) || 0;
      var ap = parseFloat(apIn.value) || 0;
      heads.forEach(function (h, i) {
        var e = parseFloat(h.getAttribute('data-epfl')) || 0;
        var fs = parseFloat(h.getAttribute('data-fs')) || 0;
        var af = parseFloat(h.getAttribute('data-afov')) || 0;
        var m = '—<small>pick a scope</small>', t = m, x = m;
        if (fl > 0 && e > 0) {
          var mag = fl / e;
          var warn = ap > 0 && mag > ap * 2 ? '<small>above useful max</small>' : '<small>&nbsp;</small>';
          m = Math.round(mag) + 'x' + warn;
          var tf = fs > 0 ? fs / fl * 57.2958 : (af ? af / mag : 0);
          t = tf ? fmtDeg(tf) + '<small>' + (tf >= 0.5 ? 'fits the full Moon' : 'tighter than the Moon') + '</small>' : '—';
          x = ap > 0 ? (ap / mag).toFixed(1) + 'mm<small>exit pupil</small>' : '—<small>add aperture</small>';
        }
        if (cells.mag[i]) cells.mag[i].innerHTML = m;
        if (cells.tfov[i]) cells.tfov[i].innerHTML = t;
        if (cells.ep[i]) cells.ep[i].innerHTML = x;
      });
    }
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      flIn.value = sel.value || '';
      apIn.value = (o && o.getAttribute('data-ap')) || '';
      update();
    });
    if (flIn) flIn.addEventListener('input', function () { if (sel) sel.value = ''; update(); });
    if (apIn) apIn.addEventListener('input', update);
  }

  /* ---- upsell add to cart ---- */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-es-add]');
    if (!b || b.disabled) return;
    ev.preventDefault();
    b.disabled = true; b.textContent = 'Adding…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-es-add'), 10), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function () {
      b.textContent = 'Added ✓';
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (b.closest('.es-upsell--cart')) { setTimeout(function () { location.reload(); }, 500); }
    }).catch(function () { b.textContent = 'Try again'; b.disabled = false; });
  });

  function placeUpsell() {
    var m = document.querySelector('[data-es-upsell-mount]');
    if (!m) return;
    var kind = m.getAttribute('data-es-upsell-mount');
    var target = null;
    if (kind === 'product') {
      var pr = document.querySelector('product-rerender[id^="product-info-"]');
      target = pr && pr.closest('.shopify-section');
      if (target) target.insertAdjacentElement('afterend', m);
    } else {
      target = document.querySelector('.order-summary');
      if (target) target.insertAdjacentElement('afterend', m);
    }
  }


  /* ---- "New" pills in navigation (menu titles ending/starting with "· New") ---- */
  function initPills(root) {
    (root || document).querySelectorAll('store-header a, navigation-drawer a, .header a, .header summary').forEach(function (a) {
      if (a.querySelector('.es-pill')) return;
      var w = document.createTreeWalker(a, NodeFilter.SHOW_TEXT), n, hits = [];
      while ((n = w.nextNode())) { if (/\s·\s*New\s*$/.test(n.nodeValue) || /^\s*New\s*·\s/.test(n.nodeValue)) hits.push(n); }
      hits.forEach(function (t) {
        var pre = /^\s*New\s*·\s/.test(t.nodeValue);
        t.nodeValue = t.nodeValue.replace(/\s·\s*New\s*$/, '').replace(/^\s*New\s*·\s/, '');
        var p = document.createElement('span'); p.className = 'es-pill'; p.textContent = 'New';
        if (pre) { t.parentNode.insertBefore(p, t); t.parentNode.insertBefore(document.createTextNode(' '), t); }
        else { t.parentNode.insertBefore(document.createTextNode(' '), t.nextSibling); t.parentNode.insertBefore(p, t.nextSibling.nextSibling); }
      });
    });
  }


  /* ---- sticky add to cart (product pages) ---- */
  function initStickyAtc() {
    if (!/\/products\//.test(location.pathname) || document.querySelector('.es-satc')) return;
    var btn = document.querySelector('product-info buy-buttons button[type="submit"], .product-info buy-buttons button[type="submit"]') || document.querySelector('buy-buttons button[type="submit"]');
    if (!btn) return;
    var css = document.createElement('style');
    css.textContent = '.es-satc{position:fixed;left:0;right:0;bottom:0;z-index:25;transform:translateY(115%);transition:transform .35s cubic-bezier(.2,.7,.2,1);padding:10px 12px calc(10px + env(safe-area-inset-bottom));pointer-events:none}' +
      '.es-satc.is-on{transform:none;pointer-events:auto}' +
      '.es-satc__in{max-width:1100px;margin:0 auto;display:flex;align-items:center;gap:14px;background:rgba(13,13,15,.88);-webkit-backdrop-filter:blur(14px);backdrop-filter:blur(14px);border:1px solid rgba(255,204,51,.28);border-radius:18px;padding:10px 10px 10px 12px;box-shadow:0 20px 50px rgba(0,0,0,.6)}' +
      '.es-satc__img{width:52px;height:52px;object-fit:contain;background:#fff;border-radius:10px;flex:none}' +
      '.es-satc__txt{min-width:0;flex:1}' +
      '.es-satc__t{font-weight:600;font-size:14px;line-height:1.25;color:#f5f5f7;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.es-satc__p{font-size:15px;font-weight:700;color:var(--es-gold,#ffcc33);margin-top:2px}' +
      '.es-satc__btn{flex:none;min-height:46px;padding:0 26px;border-radius:999px;border:0;background:#2997ff;color:#fff;font-weight:700;font-size:15px;cursor:pointer;transition:background .2s}' +
      '.es-satc__btn:hover{background:#0077ed}' +
      '.es-satc__btn[disabled]{background:#3a3a3e;color:rgba(255,255,255,.6);cursor:default}' +
      '@media (max-width:699px){.es-satc{padding:8px 8px calc(8px + env(safe-area-inset-bottom))}.es-satc__in{gap:10px;padding:8px 8px 8px 8px}.es-satc__img{width:44px;height:44px}.es-satc__t{font-size:13px}.es-satc__p{font-size:14px}.es-satc__btn{padding:0 18px;font-size:14px;min-height:44px}}';
    document.head.appendChild(css);
    var bar = document.createElement('div');
    bar.className = 'es-satc';
    bar.innerHTML = '<div class="es-satc__in"><img class="es-satc__img" alt="" width="52" height="52"><div class="es-satc__txt"><div class="es-satc__t"></div><div class="es-satc__p"></div></div><button type="button" class="es-satc__btn"></button></div>';
    document.body.appendChild(bar);
    var img = bar.querySelector('.es-satc__img'), tt = bar.querySelector('.es-satc__t'), pp = bar.querySelector('.es-satc__p'), bb = bar.querySelector('.es-satc__btn');
    var og = document.querySelector('meta[property="og:image"]');
    if (og && og.content) img.src = og.content.replace(/^http:/, 'https:'); else img.style.display = 'none';
    var h1 = document.querySelector('.product-info h1, product-info h1, .product-info .product-title, h1');
    tt.textContent = h1 ? h1.textContent.trim() : document.title;
    function sync() {
      var pr = document.querySelector('.product-info price-list sale-price, product-info price-list sale-price, price-list sale-price');
      pp.textContent = pr ? pr.textContent.replace(/Sale price|Regular price|From/gi, '').replace(/\s+/g, ' ').trim() : '';
      var off = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
      bb.textContent = (btn.innerText || btn.textContent || '').trim() || 'Add to cart';
      bb.disabled = off;
    }
    bb.addEventListener('click', function () { if (!bb.disabled) btn.click(); });
    var ticking = false;
    function check() {
      ticking = false;
      var r = btn.getBoundingClientRect();
      var on = r.bottom < 0 || (r.width === 0 && window.scrollY > 600);
      var qa = document.querySelector('product-quick-add');
      if (qa && qa.offsetHeight > 0) on = false;
      if (on) sync();
      bar.classList.toggle('is-on', on);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* ---- sold out / coming soon buy box ---- */
  function initComingSoon() {
    if (!/\/products\//.test(location.pathname)) return;
    var st = document.createElement('style');
    st.textContent = 'buy-buttons:has(button[type="submit"][disabled]) .shopify-payment-button{display:none!important}.es-cs .product-info .badge--sold-out{display:none!important}buy-buttons button[type="submit"][disabled]{background:transparent!important;border:1px solid rgba(255,204,51,.5)!important;color:#ffcc33!important;opacity:1!important;cursor:default}';
    document.head.appendChild(st);
    var cs = Array.prototype.some.call(document.querySelectorAll('.product-info .badge'), function (b) { return /coming soon/i.test(b.textContent); });
    if (!cs) return;
    document.documentElement.classList.add('es-cs');
    function fix() {
      document.querySelectorAll('buy-buttons button[type="submit"][disabled]').forEach(function (b) {
        var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) { if (/sold out/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/sold out/i, 'Coming soon'); }
      });
    }
    fix();
    new MutationObserver(fix).observe(document.querySelector('.product-info') || document.body, { subtree: true, childList: true, characterData: true });
  }

  function navCss() {
    var st = document.createElement('style');
    st.textContent = '.header .mega-menu__nav{flex:0 1 auto;flex-wrap:wrap;row-gap:28px;min-width:0}.header .mega-menu__nav > li{padding:0 24px 0 0;margin-right:24px;min-width:150px}.header .mega-menu .navigation-promo__wrapper{min-width:0}@media (max-width:1399px){.header .mega-menu{gap:40px!important}.header .mega-menu__nav > li{padding-right:18px;margin-right:18px;min-width:140px}}';
    document.head.appendChild(st);
  }

  function boot() {
    navCss();
    placeUpsell();
    initComingSoon();
    initStickyAtc();
    initPills();
    initReveal();
    document.querySelectorAll('[data-es-explode]').forEach(initExplode);
    document.querySelectorAll('[data-es-ss]').forEach(initCalc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); var x = e.target.querySelector('[data-es-explode]'); if (x) initExplode(x); var c = e.target.querySelector('[data-es-ss]'); if (c) initCalc(c); });
})();